module.exports = __webpack_public_path__ + "img/qian.14168224.svg";